/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  QueuesMethods,
  QueuesMethodsInterface,
  QueuesConstructor,
} from "../QueuesMethods";

const _abi = [
  {
    inputs: [
      {
        components: [
          {
            internalType: "address[]",
            name: "operators",
            type: "address[]",
          },
          {
            internalType: "address",
            name: "methods",
            type: "address",
          },
          {
            internalType: "address",
            name: "restricted",
            type: "address",
          },
          {
            internalType: "address",
            name: "queues",
            type: "address",
          },
          {
            internalType: "address",
            name: "zerocost",
            type: "address",
          },
          {
            internalType: "address",
            name: "arenas",
            type: "address",
          },
          {
            internalType: "address",
            name: "hounds",
            type: "address",
          },
          {
            internalType: "address",
            name: "payments",
            type: "address",
          },
          {
            internalType: "address",
            name: "races",
            type: "address",
          },
          {
            internalType: "address",
            name: "raceUploader",
            type: "address",
          },
          {
            internalType: "bytes4[][]",
            name: "targets",
            type: "bytes4[][]",
          },
        ],
        internalType: "struct QueuesConstructor.Struct",
        name: "input",
        type: "tuple",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "DeleteQueue",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        components: [
          {
            components: [
              {
                internalType: "string",
                name: "name",
                type: "string",
              },
              {
                internalType: "address",
                name: "feeCurrency",
                type: "address",
              },
              {
                internalType: "address",
                name: "raceEntryTicketCurrency",
                type: "address",
              },
              {
                internalType: "uint256[]",
                name: "participants",
                type: "uint256[]",
              },
              {
                internalType: "uint256[]",
                name: "enqueueDates",
                type: "uint256[]",
              },
              {
                internalType: "uint256",
                name: "arena",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "raceEntryTicket",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "fee",
                type: "uint256",
              },
            ],
            internalType: "struct Core.Struct",
            name: "core",
            type: "tuple",
          },
          {
            internalType: "uint256[]",
            name: "speciesAllowed",
            type: "uint256[]",
          },
          {
            internalType: "uint256",
            name: "startDate",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "endDate",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "lastCompletion",
            type: "uint256",
          },
          {
            internalType: "uint32",
            name: "totalParticipants",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "cooldown",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "staminaCost",
            type: "uint32",
          },
          {
            internalType: "bool",
            name: "closed",
            type: "bool",
          },
        ],
        indexed: false,
        internalType: "struct Queue.Struct",
        name: "queue",
        type: "tuple",
      },
    ],
    name: "EditQueue",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "hound",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "player",
        type: "address",
      },
    ],
    name: "PlayerEnqueue",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "QueueClosed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "idStart",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "idStop",
        type: "uint256",
      },
      {
        components: [
          {
            components: [
              {
                internalType: "string",
                name: "name",
                type: "string",
              },
              {
                internalType: "address",
                name: "feeCurrency",
                type: "address",
              },
              {
                internalType: "address",
                name: "raceEntryTicketCurrency",
                type: "address",
              },
              {
                internalType: "uint256[]",
                name: "participants",
                type: "uint256[]",
              },
              {
                internalType: "uint256[]",
                name: "enqueueDates",
                type: "uint256[]",
              },
              {
                internalType: "uint256",
                name: "arena",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "raceEntryTicket",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "fee",
                type: "uint256",
              },
            ],
            internalType: "struct Core.Struct",
            name: "core",
            type: "tuple",
          },
          {
            internalType: "uint256[]",
            name: "speciesAllowed",
            type: "uint256[]",
          },
          {
            internalType: "uint256",
            name: "startDate",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "endDate",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "lastCompletion",
            type: "uint256",
          },
          {
            internalType: "uint32",
            name: "totalParticipants",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "cooldown",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "staminaCost",
            type: "uint32",
          },
          {
            internalType: "bool",
            name: "closed",
            type: "bool",
          },
        ],
        indexed: false,
        internalType: "struct Queue.Struct[]",
        name: "newQueues",
        type: "tuple[]",
      },
    ],
    name: "QueuesCreation",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "hound",
        type: "uint256",
      },
    ],
    name: "Unenqueue",
    type: "event",
  },
  {
    inputs: [],
    name: "control",
    outputs: [
      {
        internalType: "address",
        name: "methods",
        type: "address",
      },
      {
        internalType: "address",
        name: "restricted",
        type: "address",
      },
      {
        internalType: "address",
        name: "queues",
        type: "address",
      },
      {
        internalType: "address",
        name: "zerocost",
        type: "address",
      },
      {
        internalType: "address",
        name: "arenas",
        type: "address",
      },
      {
        internalType: "address",
        name: "hounds",
        type: "address",
      },
      {
        internalType: "address",
        name: "payments",
        type: "address",
      },
      {
        internalType: "address",
        name: "races",
        type: "address",
      },
      {
        internalType: "address",
        name: "raceUploader",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "queueId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "hound",
        type: "uint256",
      },
    ],
    name: "enqueue",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "queueId",
        type: "uint256",
      },
    ],
    name: "enqueueDatesOf",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "id",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "queueId",
        type: "uint256",
      },
    ],
    name: "participantsOf",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "queueId",
        type: "uint256",
      },
    ],
    name: "queue",
    outputs: [
      {
        components: [
          {
            components: [
              {
                internalType: "string",
                name: "name",
                type: "string",
              },
              {
                internalType: "address",
                name: "feeCurrency",
                type: "address",
              },
              {
                internalType: "address",
                name: "raceEntryTicketCurrency",
                type: "address",
              },
              {
                internalType: "uint256[]",
                name: "participants",
                type: "uint256[]",
              },
              {
                internalType: "uint256[]",
                name: "enqueueDates",
                type: "uint256[]",
              },
              {
                internalType: "uint256",
                name: "arena",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "raceEntryTicket",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "fee",
                type: "uint256",
              },
            ],
            internalType: "struct Core.Struct",
            name: "core",
            type: "tuple",
          },
          {
            internalType: "uint256[]",
            name: "speciesAllowed",
            type: "uint256[]",
          },
          {
            internalType: "uint256",
            name: "startDate",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "endDate",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "lastCompletion",
            type: "uint256",
          },
          {
            internalType: "uint32",
            name: "totalParticipants",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "cooldown",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "staminaCost",
            type: "uint32",
          },
          {
            internalType: "bool",
            name: "closed",
            type: "bool",
          },
        ],
        internalType: "struct Queue.Struct",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "queues",
    outputs: [
      {
        components: [
          {
            internalType: "string",
            name: "name",
            type: "string",
          },
          {
            internalType: "address",
            name: "feeCurrency",
            type: "address",
          },
          {
            internalType: "address",
            name: "raceEntryTicketCurrency",
            type: "address",
          },
          {
            internalType: "uint256[]",
            name: "participants",
            type: "uint256[]",
          },
          {
            internalType: "uint256[]",
            name: "enqueueDates",
            type: "uint256[]",
          },
          {
            internalType: "uint256",
            name: "arena",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "raceEntryTicket",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "fee",
            type: "uint256",
          },
        ],
        internalType: "struct Core.Struct",
        name: "core",
        type: "tuple",
      },
      {
        internalType: "uint256",
        name: "startDate",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "endDate",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "lastCompletion",
        type: "uint256",
      },
      {
        internalType: "uint32",
        name: "totalParticipants",
        type: "uint32",
      },
      {
        internalType: "uint32",
        name: "cooldown",
        type: "uint32",
      },
      {
        internalType: "uint32",
        name: "staminaCost",
        type: "uint32",
      },
      {
        internalType: "bool",
        name: "closed",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address[]",
            name: "operators",
            type: "address[]",
          },
          {
            internalType: "address",
            name: "methods",
            type: "address",
          },
          {
            internalType: "address",
            name: "restricted",
            type: "address",
          },
          {
            internalType: "address",
            name: "queues",
            type: "address",
          },
          {
            internalType: "address",
            name: "zerocost",
            type: "address",
          },
          {
            internalType: "address",
            name: "arenas",
            type: "address",
          },
          {
            internalType: "address",
            name: "hounds",
            type: "address",
          },
          {
            internalType: "address",
            name: "payments",
            type: "address",
          },
          {
            internalType: "address",
            name: "races",
            type: "address",
          },
          {
            internalType: "address",
            name: "raceUploader",
            type: "address",
          },
          {
            internalType: "bytes4[][]",
            name: "targets",
            type: "bytes4[][]",
          },
        ],
        internalType: "struct QueuesConstructor.Struct",
        name: "globalParameters",
        type: "tuple",
      },
    ],
    name: "setGlobalParameters",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "queueId",
        type: "uint256",
      },
    ],
    name: "staminaCostOf",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "queueId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "hound",
        type: "uint256",
      },
    ],
    name: "unenqueue",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "whitelists",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

type QueuesMethodsConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: QueuesMethodsConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class QueuesMethods__factory extends ContractFactory {
  constructor(...args: QueuesMethodsConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "QueuesMethods";
  }

  deploy(
    input: QueuesConstructor.StructStruct,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<QueuesMethods> {
    return super.deploy(input, overrides || {}) as Promise<QueuesMethods>;
  }
  getDeployTransaction(
    input: QueuesConstructor.StructStruct,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(input, overrides || {});
  }
  attach(address: string): QueuesMethods {
    return super.attach(address) as QueuesMethods;
  }
  connect(signer: Signer): QueuesMethods__factory {
    return super.connect(signer) as QueuesMethods__factory;
  }
  static readonly contractName: "QueuesMethods";
  public readonly contractName: "QueuesMethods";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): QueuesMethodsInterface {
    return new utils.Interface(_abi) as QueuesMethodsInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): QueuesMethods {
    return new Contract(address, _abi, signerOrProvider) as QueuesMethods;
  }
}
